<div>
  <ng-container [ngSwitch]="reportUrl">
    <app-existing-batch-report *ngSwitchCase="'BatchReport'" [theme]="theme" />
    <app-existing-report-daily-summary-table *ngSwitchDefault [theme]="theme" />
    <app-existing-sdk-batch-report *ngSwitchCase="'SdkBatchReport'" [theme]="theme" />
  </ng-container>
</div>
